export const percentFormatter = (value, ctx) => {
  const datapoints = ctx.chart.data.datasets[0].data;
  const total = datapoints.reduce((total, datapoint) => total + datapoint, 0);
  const percentage = ((value / total) * 100).toFixed(2);
  return percentage + '%';
};
